import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-h03" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-the-page-h03-detail" }
const _hoisted_9 = { class: "p-the-page-h03-detail__text" }
const _hoisted_10 = { class: "p-the-page-h03-price" }
const _hoisted_11 = {
  key: 0,
  class: "p-the-page-h03-price__note"
}
const _hoisted_12 = { class: "p-the-page-h03__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_SmallText = _resolveComponent("SmallText")!
  const _component_HContainer = _resolveComponent("HContainer")!
  const _component_PointNotation = _resolveComponent("PointNotation")!
  const _component_HSpecColumnList = _resolveComponent("HSpecColumnList")!
  const _component_TheHDetail = _resolveComponent("TheHDetail")!
  const _component_TheTemplateH = _resolveComponent("TheTemplateH")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheBreadcrumb),
        (_ctx.usageData.product_details)
          ? (_openBlock(), _createBlock(_component_TheTemplateH, {
              key: 0,
              heading: "ポイント詳細"
            }, {
              title: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("ポイント利用", -1)
              ])),
              contents: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_TheHDetail, {
                    image: true,
                    "usage-point": _ctx.usagePoint
                  }, _createSlots({
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_SmallText, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.appId.label) + " " + _toDisplayString(_ctx.appId.id), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "xs" }, {
                          content: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.productDetails.product_name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_HContainer, { "margin-size": "s" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_SmallText, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" 商品 No." + _toDisplayString(_ctx.productDetails.product_id), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_PointNotation, {
                                point: _ctx.productDetails.price,
                                "sign-is-exists": false,
                                "font-size": 24
                              }, null, 8, ["point"]),
                              (_ctx.productDetails.price_off)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, " （" + _toDisplayString(_ctx.productDetails.price_off) + "OFF） ", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    body: _withCtx(() => [
                      _createVNode(_component_HContainer, null, {
                        content: _withCtx(() => [
                          _createVNode(_component_SmallText, null, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("申込日", -1)
                            ])),
                            _: 1,
                            __: [1]
                          }),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.productDetails.date), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HContainer, null, {
                        content: _withCtx(() => [
                          _createVNode(_component_HSpecColumnList, { "list-item": _ctx.productDetailsSpec }, null, 8, ["list-item"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, [
                    (_ctx.productDetails.premium_id != 0)
                      ? {
                          name: "image",
                          fn: _withCtx(() => [
                            _createElementVNode("a", { href: _ctx.productDomain }, [
                              _createElementVNode("img", {
                                src: _ctx.productDetails.image,
                                class: "p-the-page-h03-product-image"
                              }, null, 8, _hoisted_6)
                            ], 8, _hoisted_5)
                          ]),
                          key: "0"
                        }
                      : {
                          name: "image",
                          fn: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.productDetails.image,
                              class: "p-the-page-h03-product-image"
                            }, null, 8, _hoisted_7)
                          ]),
                          key: "1"
                        }
                  ]), 1032, ["usage-point"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}